import React from "react";
import DesktopNavbar from "./DesktopNavbarDesign";
import MobileTopbar from "./MobileNavbarDesign";
import promoData from "../../data/promoData.json";

import { productSections } from "../../../homepage/config/productCollection";

// 1. Import your custom hooks (adjust the paths to your actual context files)
import { useCart } from "../../../../features/cart/context/CartContext";

const UserNavbar = () => {
  // 2. Extract values from context
  // Destructuring based on your commented-out code
  const { cart } = useCart();

  // 3. Calculate counts (assuming items are stored in an array)
  const cartCount =
    cart?.reduce(
      (count, item) => count + (Number(item.selectedQuantity) || 1),
      0,
    ) || 0;
  // console.log(cartCount);
  return (
    <>
      {/* Desktop View */}
      <div className="hidden md:block">
        <DesktopNavbar
          cartCount={cartCount}
          promoData={promoData}
          categoryMenuItems={productSections}
        />
      </div>

      {/* Mobile View */}
      <div className="block md:hidden">
        <MobileTopbar promoData={promoData} cartCount={cartCount} />
      </div>
    </>
  );
};

export default UserNavbar;
